import { Link, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../App";
import useInvoke from "../Tools/Invoker";
import DynamicGrid from "../Tools/DynamicGrid";
import LoginRedirect from "../Page/LoginRedirect";
import CheckToken from "../_Login/CheckToken";
import toast, { Toaster } from 'react-hot-toast';
import CustomerSave from "./CustomerSave";


const CustomerEdit = () => {

    const {id} = useParams();
    const [user, setUser] = useContext(UserContext);
    let navigate = useNavigate();
    CheckToken(user["id"], user["token"]).then((result) => {if(!result) {setUser({}); navigate("/Login");}});
    
    let response47 = useInvoke("WebApps", "47", {"@CustomerId": id})

    const [customer, setCustomer] = useState({});

    useEffect(() => {

        //get customer data 
        if (response47.data.payload != undefined) {
            let data = JSON.parse(response47.data.payload).data[0];

            let breakpoint = "";
            let obj = {
                customerid: data[0],
                name: data[1],
                address: data[2],
                city: data[3],
                state: data[4],
                zip: data[5]
            };


            setCustomer(obj);
        }

    }, [response47.isPending]);

    document.title = "Customers - View";
    return ( 
        <div className="customerEdit">
            {user["email"] != undefined && 
                <>
                    {customer && 
                        <div className="container body-content" style={{marginTop: "25px"}}>
                                
                        <h2>View Customer</h2>

                            <form id="customerForm" noValidate="novalidate" autoComplete="off">    

                                <div className="form-group">
                                    <label htmlFor="site">Customer ID&nbsp;</label><span style={{color: "lightgrey"}}>ⓘ&nbsp;JobBOSS Data</span>
                                    <input className="form-control" id="customerid" name="customerid" type="text" readOnly={true} defaultValue={customer["customerid"]} autoComplete="off" />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="site">Customer Name&nbsp;</label><span style={{color: "lightgrey"}}>ⓘ&nbsp;JobBOSS Data</span>
                                    <input className="form-control" id="name" name="name" type="text" readOnly={true} defaultValue={customer["name"]} autoComplete="off" />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="site">Address&nbsp;</label><span style={{color: "lightgrey"}}>ⓘ&nbsp;JobBOSS Data</span>
                                    <input className="form-control" id="address" name="address" type="text" readOnly={true} defaultValue={customer["address"]} autoComplete="off" />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="site">City&nbsp;</label><span style={{color: "lightgrey"}}>ⓘ&nbsp;JobBOSS Data</span>
                                    <input className="form-control" id="city" name="city" type="text" readOnly={true} defaultValue={customer["city"]} autoComplete="off" />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="site">State&nbsp;</label><span style={{color: "lightgrey"}}>ⓘ&nbsp;JobBOSS Data</span>
                                    <input className="form-control" id="state" name="state" type="text" readOnly={true} defaultValue={customer["state"]} autoComplete="off" />
                                </div>

                                <div className="form-group">
                                    <label htmlFor="site">Zip&nbsp;</label><span style={{color: "lightgrey"}}>ⓘ&nbsp;JobBOSS Data</span>
                                    <input className="form-control" id="zip" name="zip" type="text" readOnly={true} defaultValue={customer["zip"]} autoComplete="off" />
                                </div>

                                
                            </form>
                            <Link to="/Customer" className="btn btn-default" style={{marginRight: "4px"}}>Back</Link>                            
                        </div>
                    }
                </>
            }
        </div>
     );
}
 
export default CustomerEdit;